import { render, staticRenderFns } from "./ProductManuals.vue?vue&type=template&id=0280500e&scoped=true&lang=pug"
import script from "./ProductManuals.vue?vue&type=script&lang=js"
export * from "./ProductManuals.vue?vue&type=script&lang=js"
import style0 from "./ProductManuals.vue?vue&type=style&index=0&id=0280500e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0280500e",
  null
  
)

export default component.exports